export default {
  install: (app) => {

    let convertToSlug = (title, id, custom_url = null) => {
      if (custom_url === null) {
        return (
          title
            .replace(/ /g, "-")
            .replace(/[^\u4e00-\u9fa5a-zA-Z0-9-]+/g, "")
          + "-"
          + id
        );
      } else {
          return (
            custom_url
            // + "-"
            // + id
          );
      }
    };

    app.config.globalProperties.$convertToSlug = (title, id, custom_url) => {
      return convertToSlug(title, id, custom_url);
    };

    app.config.globalProperties.$buildBlogURL = (title, id) => {
      return '/announcement/' + convertToSlug(title, id, null, process.env.VUE_APP_BLOG_PATH);
    };
  },
};
